module.exports = __webpack_public_path__ + "static/media/KAPorgWhiteIcon.b7ca9c30.svg";